import {
  DocumentCategory,
  DocumentCategoryToText,
} from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

export const useGetDocumentCategory = () => (doc?: string) => {
  const { t: td } = useTranslation('documents');
  if (!doc) return undefined;
  return td(DocumentCategoryToText[doc as DocumentCategory]).toLowerCase();
};
